import Repository from '../Repository';

export default {

	getAllLanguages() {
		var response = Repository.get('Language/GetAllLanguages', {});
		return response;
	}

}
